import { Component, OnInit } from '@angular/core';
import { CsrgsService } from "src/app/shared/csrgs.service";

@Component({
  selector: 'app-our-moto',
  templateUrl: './our-moto.component.html',
  styleUrls: ['./our-moto.component.css']
})
export class OurMotoComponent implements OnInit {

  currentYear: number = new Date().getFullYear();
  nextYear: number = this.currentYear + 1;

  myInterval = 5000;
  activeSlideIndex = 0;

  achievementImages: { photoURL: string }[] = [];
  eventImages: { photoURL: string }[] = [];

  constructor(private service: CsrgsService) { }

  ngOnInit(): void {
    this.loadImages(16, 'event');
    this.loadImages(17, 'achievement');
  }

  loadImages(albumId: number, type: 'event' | 'achievement'): void {
    this.service.getAllBannerImages(albumId).subscribe({
      next: (data: { photoURL: string }[]) => {
        if (type === 'event') {
          this.eventImages = data;
          console.log(this.eventImages);

        } else if (type === 'achievement') {
          this.achievementImages = data;
          console.log(this.achievementImages);
        }
        console.log(`Fetched ${type} slides:`, data);
      },
      error: (err) => {
        console.error(`Failed to load ${type} banner images:`, err);
      }
    });
  }
}